<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  style="margin: auto; background: none; display: block; shape-rendering: auto"
  width="120px"
  height="120px"
  viewBox="0 0 100 100"
  preserveAspectRatio="xMidYMid"
>
  <circle cx="28" cy="75" r="11" fill="#0a0a0a">
    <animate
      attributeName="fill-opacity"
      repeatCount="indefinite"
      dur="1s"
      values="0;1;1"
      keyTimes="0;0.2;1"
      begin="0s"
    ></animate>
  </circle>

  <path
    d="M28 47A28 28 0 0 1 56 75"
    fill="none"
    stroke="#28292f"
    stroke-width="10"
  >
    <animate
      attributeName="stroke-opacity"
      repeatCount="indefinite"
      dur="1s"
      values="0;1;1"
      keyTimes="0;0.2;1"
      begin="0.1s"
    ></animate>
  </path>
  <path
    d="M28 25A50 50 0 0 1 78 75"
    fill="none"
    stroke="#ffffff"
    stroke-width="10"
  >
    <animate
      attributeName="stroke-opacity"
      repeatCount="indefinite"
      dur="1s"
      values="0;1;1"
      keyTimes="0;0.2;1"
      begin="0.2s"
    ></animate>
  </path>
</svg>

<h1 mat-dialog-title>{{ 'core.popups.offline.message' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'core.popups.offline.description' | translate }}</p>

  <div style="display: flex; justify-content: flex-start; text-align: left">
    <p>{{ 'core.popups.offline.try' | translate }}</p>
    <ul>
      <li>{{ 'core.popups.offline.instruction-1' | translate }}</li>
      <li>{{ 'core.popups.offline.instruction-2' | translate }}</li>
    </ul>
  </div>
</div>
